class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // this.open();
    });
  }
  
  renderContentsCustom(parsedState, openDrawer) {
    document.querySelector('#CartDrawer .drawer__inner').classList.contains('is-empty') &&
      document.querySelector('#CartDrawer .drawer__inner').classList.remove('is-empty');
    //this.productId = parsedState.id;
    document.querySelector('cart-drawer').getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      console.log(sectionElement, "test2");
      
      sectionElement.innerHTML = document.querySelector('cart-drawer').getSectionInnerHTML(parsedState[section.id], section.selector);
    });
    
    document.getElementsByClassName("drawer")[0].classList.remove('is-empty');
    
    setTimeout(() => {
      document.querySelector('#CartDrawer #CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if(openDrawer) {
         this.open(); 
      }
    });
  }
  
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);



// //offer script
// // Debounced version of the discount function
// const debouncedRunCartDiscountUI = debounce(runCartDiscountUI, 200);

// // --- Filter eligible items ---
// function getEligibleItems(cartItems) {
//   return cartItems.filter(item => {
//     const type = item.product_type?.toLowerCase();
//     const isExcludedType = ['flashsale', 'flashstore', 'combo', 'merch', 'free', 'lip balm', 'lip care'].includes(type);

//     return !isExcludedType;
//   });
// }


// // --- Tiered pricing with lip balm bundle logic ---
// function applyTieredPricing(cartItems) {
//   const eligibleItems = getEligibleItems(cartItems);

//   // --- Lip Balm Bundle Logic: pair lip balms for ₹350 each pair ---
//   const lipBalmItems = cartItems.filter(item => {
//     const type = item.product_type?.toLowerCase();
//     return ['lip balm', 'lip care'].includes(type);
//   });

//   let lipBalmUnits = [];
//   lipBalmItems.forEach(item => {
//     const unitPrice = item.final_line_price / item.quantity;
//     for (let i = 0; i < item.quantity; i++) {
//       lipBalmUnits.push({ key: item.key, unitPrice });
//     }
//   });

//   lipBalmUnits.sort((a, b) => b.unitPrice - a.unitPrice); // Optional: sort high to low for pairing

//   const pairCount = Math.floor(lipBalmUnits.length / 2);
//   const pairedUnitsCount = pairCount * 2;

//   const bundledLipBalmUnits = lipBalmUnits.slice(0, pairedUnitsCount); // paired items
//   const leftoverUnits = lipBalmUnits.slice(pairedUnitsCount); // unpaired items

//   let bundledLipBalm = null;
//   if (pairedUnitsCount > 0) {
//     const originalTotal = bundledLipBalmUnits.reduce((sum, unit) => sum + unit.unitPrice, 0);
//     bundledLipBalm = {
//       units: bundledLipBalmUnits,
//       discountedTotal: 35000 * pairCount,
//       originalTotal
//     };
//   }

//   // Exclude bundled lip balm units from eligible items for tier pricing
//   let bundledLipKeys = bundledLipBalm ? bundledLipBalm.units.map(u => u.key) : [];
//   const filteredItems = eligibleItems.filter(item => !bundledLipKeys.includes(item.key));

//   // Build allUnits from filteredItems
//   const allUnits = [];
//   filteredItems.forEach(item => {
//     const unitPrice = item.final_line_price / item.quantity;
//     for (let i = 0; i < item.quantity; i++) {
//       allUnits.push({ key: item.key, unitPrice });
//     }
//   });

//   // Add leftover lip balm units (not bundled) back to main pricing
//   leftoverUnits.forEach(unit => allUnits.push(unit));

//   const totalQty = allUnits.length;
//   const tierPricing = {
//     2: 69900,
//     3: 99900,
//     4: 129500,
//     5: 169800,
//     6: 199800,
//     7: 199800,
//     8: 259000,
//     9: 299700
//   };

//   const validTierQuantities = Object.keys(tierPricing).map(Number);
//   const isTierValid = validTierQuantities.includes(totalQty);
//   const totalActualPrice = allUnits.reduce((sum, unit) => sum + unit.unitPrice, 0);
//   const tierPrice = tierPricing[totalQty] || 0;

//   let discountedTotal = tierPrice;
//   let fullPriceUnits = [];

//   if (!isTierValid || totalActualPrice < tierPrice) {
//     discountedTotal = null;
//   }

//   if (totalQty === 7) {
//     discountedTotal = tierPricing[7] + allUnits[6].unitPrice;
//   } else if (totalQty >= 10) {
//     discountedTotal = tierPricing[9];
//     fullPriceUnits = allUnits.slice(9);
//   }

//   const discountedItems = [];
//   if (discountedTotal !== null) {
//     const discountedUnits = allUnits.slice(0, totalQty - fullPriceUnits.length);
//     const originalDiscountedTotal = discountedUnits.reduce((sum, unit) => sum + unit.unitPrice, 0);

//     const discountedItemsMap = {};
//     discountedUnits.forEach(unit => {
//       if (!discountedItemsMap[unit.key]) {
//         discountedItemsMap[unit.key] = {
//           quantity: 0,
//           original_total: 0,
//           unit_price: unit.unitPrice
//         };
//       }
//       discountedItemsMap[unit.key].quantity += 1;
//       discountedItemsMap[unit.key].original_total += unit.unitPrice;
//     });

//     Object.entries(discountedItemsMap).forEach(([key, item]) => {
//       const ratio = item.original_total / originalDiscountedTotal;
//       discountedItems.push({
//         key,
//         quantity: item.quantity,
//         original_per_unit: item.unit_price,
//         discounted_total: discountedTotal * ratio
//       });
//     });
//   }

//   // Add bundled lip balm discount
//   if (bundledLipBalm) {
//     const balmMap = {};
//     bundledLipBalm.units.forEach(unit => {
//       if (!balmMap[unit.key]) {
//         balmMap[unit.key] = {
//           quantity: 0,
//           original_total: 0,
//           unit_price: unit.unitPrice
//         };
//       }
//       balmMap[unit.key].quantity += 1;
//       balmMap[unit.key].original_total += unit.unitPrice;
//     });

//     Object.entries(balmMap).forEach(([key, item]) => {
//       const ratio = item.original_total / bundledLipBalm.originalTotal;
//       discountedItems.push({
//         key,
//         quantity: item.quantity,
//         original_per_unit: item.unit_price,
//         discounted_total: bundledLipBalm.discountedTotal * ratio
//       });
//     });
//   }

//   const nonDiscountedItems = [];

//   // Add leftover lip balm units (odd item)
//   leftoverUnits.forEach(unit => {
//     const existing = nonDiscountedItems.find(i => i.key === unit.key && i.original_per_unit === unit.unitPrice);
//     if (existing) {
//       existing.quantity += 1;
//     } else {
//       nonDiscountedItems.push({
//         key: unit.key,
//         original_per_unit: unit.unitPrice,
//         quantity: 1
//       });
//     }
//   });

//   // Add full price tier overflow units
//   fullPriceUnits.forEach(unit => {
//     const existing = nonDiscountedItems.find(i => i.key === unit.key && i.original_per_unit === unit.unitPrice);
//     if (existing) {
//       existing.quantity += 1;
//     } else {
//       nonDiscountedItems.push({
//         key: unit.key,
//         original_per_unit: unit.unitPrice,
//         quantity: 1
//       });
//     }
//   });

//   if (discountedItems.length === 0 && nonDiscountedItems.length === 0) return null;

//   return {
//     discountedItems,
//     nonDiscountedItems
//   };
// }

// // --- Update UI display ---
// function updateCartPricesDisplay(data) {
//   const { discountedItems, nonDiscountedItems } = data;

// document.querySelectorAll('.cart-item').forEach(el => {
//   const oldPriceEl = el.querySelector('.cart-item__old-price');
//   const newPriceEl = el.querySelector('.cart-item__final-price');

//   if (!oldPriceEl || !newPriceEl) return;

//   oldPriceEl.style.display = 'none';

//   const original = oldPriceEl.dataset.originalPrice;
//   if (original) newPriceEl.innerText = original;
// });


//   discountedItems.forEach(item => {
//     const el = document.querySelector(`[data-key="${item.key}"]`);
//     if (!el) return;

//     const oldPriceEl = el.querySelector('.cart-item__old-price');
//     const newPriceEl = el.querySelector('.cart-item__final-price');

//     const originalTotal = item.original_per_unit * item.quantity;
//     const discountedTotal = item.discounted_total;

//     if (oldPriceEl && newPriceEl) {
//       oldPriceEl.innerText = `₹${(originalTotal / 100).toFixed(2)}`;
//       oldPriceEl.style.display = 'inline-block';
//       newPriceEl.innerText = `₹${(discountedTotal / 100).toFixed(2)}`;
//     }
//   });

//   nonDiscountedItems.forEach(item => {
//     const el = document.querySelector(`[data-key="${item.key}"]`);
//     if (!el) return;

//     const newPriceEl = el.querySelector('.cart-item__final-price');
//     const oldPriceEl = el.querySelector('.cart-item__old-price');
//     const originalTotal = item.original_per_unit * item.quantity;

//     if (newPriceEl) {
//       newPriceEl.innerText = `₹${(originalTotal / 100).toFixed(2)}`;
//     }
//     if (oldPriceEl) {
//       oldPriceEl.style.display = 'none';
//     }
//   });
// }

// // --- Main logic trigger ---
// function runCartDiscountUI() {
//   fetch('/cart.js')
//     .then(response => {
//       if (!response.ok) throw new Error('Cart fetch failed');
//       return response.json();
//     })
//     .then(cart => {
//       const data = applyTieredPricing(cart.items);

//       if (data) {
//         updateCartPricesDisplay(data);
//       } else {
//         resetCartPricesToOriginal();
//       }
//     })
//     .catch(error => {
//       console.error('Error in runCartDiscountUI:', error);
//     });
// }
// function resetCartPricesToOriginal() {
//   const cartItems = document.querySelectorAll('.cart-item');
//   cartItems.forEach(item => {
//     const oldPrice = item.querySelector('.cart-item__old-price');
//     const newPrice = item.querySelector('.cart-item__final-price');
//     if (!oldPrice || !newPrice) return;
//     // Hide the old price
//     oldPrice.style.display = 'none';
//     // Restore original price if available
//     const original = oldPrice.dataset.originalPrice;
//     if (original) {
//       newPrice.innerText = original;
//     }
//   });
// }


// // --- DOM observer for cart drawer ---
// function observeCartDrawerChanges() {
//   const target = document.querySelector('body');
//   if (!target) return;

//   const observer = new MutationObserver(() => {
//     requestAnimationFrame(() => {
//       debouncedRunCartDiscountUI();
//     });
//   });

//   observer.observe(target, {
//     childList: true,
//     subtree: true
//   });
// }

// // --- Initial triggers ---
// document.addEventListener('DOMContentLoaded', debouncedRunCartDiscountUI);
// document.addEventListener('shopify:section:load', debouncedRunCartDiscountUI);
// observeCartDrawerChanges();

// // --- Instant update after add-to-cart using vanilla JavaScript ---
// document.addEventListener('submit', function(e) {
//   // Check if the submitted form is a cart add form
//   if (e.target.matches('form[action="/cart/add"]')) {
//     e.preventDefault();
    
//     const form = e.target;
//     const formData = new FormData(form);
    
//     // Convert FormData to URLSearchParams for proper serialization
//     const params = new URLSearchParams();
//     for (const [key, value] of formData.entries()) {
//       params.append(key, value);
//     }
    
//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded',
//         'X-Requested-With': 'XMLHttpRequest'
//       },
//       body: params.toString()
//     })
//     .then(response => {
//       if (!response.ok) {
//         throw new Error('Network response was not ok');
//       }
//       return response.json();
//     })
//     .then(data => {
//       // Success callback
//       setTimeout(() => {
//         debouncedRunCartDiscountUI();
//       }, 2);
//     })
//     .catch(error => {
//       console.error('Error adding to cart:', error);
//     });
//   }
// });

///////////////////////////////////////////////////////////////////////////////////////////////////
// this code run on BAU Time When we are use normal buissness (15% Offer)
///////////////////////////////////////////////////////////////////////////

function applyCartLevelDiscount() {
  const wrappers = document.querySelectorAll(".cart-item__price-wrapper");
  if (!wrappers.length) return;

  // 2. grab elements (HTMLCollection)
  const promoCodeTag = document.getElementsByClassName("promo-code-tag")[0];
  // 3. check existence
  // if (!elems || elems.length === 0) {
  //   console.warn('No element found with class .promo-code-tag');
  //   return;
  // }

  let cartTotal = 0;
  let nonComboTotal = 0;
  const items = [];
  let hasComboProduct = false;
  let hasNonComboProduct = false;
  let savingAmount = 0;

  wrappers.forEach(wrapper => {
    const cartItem = wrapper.closest(".cart-item");
    if (!cartItem || wrapper.closest(".cart_offer_product_wrap")) return;

    const productType = cartItem.getAttribute("data-product-type")?.trim().toLowerCase() || "";
    const productwape = cartItem.getAttribute("data-product-line")?.trim().toLowerCase() || "";
    let originalPrice = wrapper.getAttribute("data-original-price");
    
    if (!originalPrice) {
      const priceEl = wrapper.querySelector(".original_line_price") || wrapper.querySelector(".price");
      if (!priceEl) return;

      originalPrice = priceEl.textContent.replace(/[^0-9.]/g, "");
      wrapper.setAttribute("data-original-price", originalPrice);
    }

    const totalPrice = parseFloat(originalPrice);
    if (isNaN(totalPrice) || totalPrice <= 0) return;

    // cartTotal += totalPrice;
    //     //checking swap_line_item exit than total will exxlude the swap_line_item total price
  if(productwape !="swap_line_item") { cartTotal += totalPrice;}

    const isCombo = productType === "combo";
    if (isCombo) {
      hasComboProduct = true;
    } else {
      hasNonComboProduct = true;
      nonComboTotal += totalPrice;
    }

    items.push({
      wrapper,
      totalPrice,
      isCombo,
      productwape
    });
  });
  

  let comboDiscount = 0;
  let nonComboDiscount = 0;

  if (hasComboProduct && hasNonComboProduct) {
    // Mixed cart (combo + non-combo)
    comboDiscount = 25;
    nonComboDiscount = cartTotal >= 999 ? 20 : 15;
  } else {
    // Only combo or only non-combo
    if (hasComboProduct) {
      comboDiscount = 25; 
    }

    if (hasNonComboProduct) {
      nonComboDiscount = cartTotal >= 999 ? 20 : 15;
    }
  }

  items.forEach(({ wrapper, totalPrice, isCombo, productwape }) => {
    const formatPrice = (price) => `₹${price.toLocaleString("en-IN")}`;
    const discountPercent = isCombo ? comboDiscount : nonComboDiscount;

    if (discountPercent === 0) {
      wrapper.innerHTML = `<span class="original_line_price">${formatPrice(totalPrice)}</span>`;
    } else {
      const discountedTotal = Math.floor(totalPrice * (1 - discountPercent / 100));

      // calculate saving amount
      if(productwape !="swap_line_item"){
        savingAmount += Math.floor(totalPrice - discountedTotal);
      }

      wrapper.innerHTML = `
        <div class="cart-item__discounted-prices">
          <s class="cart-item__old-price price price--end">${formatPrice(totalPrice)}</s>
          <span class="price price--end">${formatPrice(discountedTotal)}</span>
        </div>
      `;
    }
  });

  // update total saving
  // console.log("savingAmount", savingAmount);

  if (promoCodeTag) {
    promoCodeTag.textContent = `You saved ₹${savingAmount}`;
  } else {
    console.warn("Element with class .promo-code-tag not found!");
  }
}

// Optional: Reset discount if needed
function removeDiscountFrom(wrapper) {
  const original = wrapper.getAttribute("data-original-price");
  if (original) {
    wrapper.innerHTML = `<span class="original_line_price">₹${parseFloat(original).toLocaleString("en-IN")}</span>`;
  }
}

// Init logic
document.addEventListener("DOMContentLoaded", function () {
  const applyWithDelay = () => setTimeout(applyCartLevelDiscount, 200);

  applyCartLevelDiscount();

  // Listen to quantity changes
  document.querySelectorAll(".quantity__input").forEach(input =>
    input.addEventListener("change", applyWithDelay)
  );
  document.querySelectorAll(".quantity__button").forEach(btn =>
    btn.addEventListener("click", applyWithDelay)
  );

  // Watch for dynamic cart changes
  const target = document.querySelector(".cart-items, #CartDrawer, .cart-drawer");
  if (target) {
    const observer = new MutationObserver(() => {
        //checking the swap item available into the sessionstorage than removed
   
   if (sessionStorage.getItem('swap_parentVariantId')) {
      document.querySelectorAll('.test_cdw,#CartDrawer-Item-text_swaper_t')
        .forEach(el => el.remove());
    }

   //checking the swap item available into the sessionstorage than removed
     
      applyWithDelay();
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
    });
  }
});
